exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-between[data-v-3f295894]{justify-content:space-between}.flex-end[data-v-3f295894]{justify-content:flex-end}.sfe-header-more[data-v-3f295894]{width:100%;height:0.16667rem;display:flex;align-items:center}.sfe-header-more .title[data-v-3f295894]{font-weight:600;font-size:0.08333rem;line-height:0.20833rem;color:#272727}.sfe-header-more .button[data-v-3f295894]{font-size:0.07292rem;color:#272727}\n", ""]);

// exports
